import { AssetTypes } from './enums/AssetTypes';

// tslint:disable-next-line: no-reserved-keywords
export function getAssetThumbnailUrl(asset: { id: string; type: string; filenameThumbnail?: string | null }): string {
    if (asset.type === AssetTypes.MeasurementXLS) {
        return '/assets/img/excel_thmb.png';
    }
    if (asset.type === AssetTypes.MeasurementPDF) {
        if (asset.filenameThumbnail) {
            return `/api/assets/${asset.id}/download?thumb=true`;
        }
        return '/assets/img/pdf_thmb.png';
    }
    if (asset.type === AssetTypes.Image || asset.type === AssetTypes.Image360 || asset.type === AssetTypes.ImageTif) {
        if (asset.filenameThumbnail) {
            return `/api/assets/${asset.id}/download?thumb=true`;
        }
        return '/assets/img/image_thmb.png';
    }
    return `/api/assets/${asset.id}/download?thumb=true`;
}
